export class ExtraccionAnalitica {
  idPaciente?: string;
  observaciones: string;
  emisor: string;
  fechaRegistro?: string;
  fechaActividad: string;
  tipoExtraccion: string;
}
